import { render, staticRenderFns } from "./gzwxDialog.vue?vue&type=template&id=514ee620&"
import script from "./gzwxDialog.vue?vue&type=script&lang=js&"
export * from "./gzwxDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports